import script from "./ChangeModemDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeModemDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChangeModemDialog.vue?vue&type=style&index=0&id=38d8794b&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d8794b"]])

export default __exports__